// import axios from 'axios'
// import qs from 'qs' // ✅ import qs

// const API_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_URL

// export const fetchAccountStatusList = (module: string, params: any) =>
//   axios.get(`${API_URL}/account-status/${module}`, {
//     params,
//     paramsSerializer: (params) =>
//       qs.stringify(params, { arrayFormat: 'repeat' }) // ✅ no `[]` in array keys
//   })
import axios from 'axios'
const API_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_URL

export const fetchAccountStatusList = (module: string, params: any) =>
  axios.get(`${API_URL}/case-reports`, {params: {...params, module}})
